<template>
  <v-container fluid>
    <v-form ref="form">
      <v-row class="fill-height">
        <v-col md="6" class="d-flex align-center justify-center">
          <v-img contain aspect-ratio="2" src="@/assets/sastra_logo.png" />
        </v-col>
        <v-col
          md="6"
          class="d-flex align-center justify-center primary"
          style="height: 100vh"
        >
          <v-card width="70%" color="" flat class="pa-5">
            <v-card-title class="d-flex justify-center">
              <!-- <h2 class="title-login">Sastra</h2> -->
            </v-card-title>
            <v-card-text>
              <v-col md="12" class="py-0 px-0">
                <v-text-field
                  v-model="form.email"
                  label="Email*"
                  persistent-placeholder
                  outlined
                  :rules="[rules.required, rules.email]"
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="12" class="py-0 px-0">
                <v-text-field
                  v-model="form.password"
                  label="Password*"
                  persistent-placeholder
                  :type="showPassword ? 'text' : 'password'"
                  outlined
                  :rules="[rules.required]"
                  dense
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-col>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
              <v-btn
                color="secondary"
                class="primary pa-4"
                small
                outlined
                rounded
                @click="signIn"
                >Sign In</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { rules } from "@/helpers/rules";
export default {
  name: "LoginPage",
  data() {
    return {
      rules,
      form: {},
      showPassword: false,
    };
  },
  methods: {
    async signIn() {
      if (!this.$refs.form.validate()) return;
      await this.$axios
        .post("sessions/login", {
          email: this.form.email,
          password: this.form.password,
        })
        .then((res) => {
          const { token, user } = res.data.data;
          this.$store.commit("setUser", user);
          localStorage.setItem("token", token);
          this.$axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${token}`;

          if (user.role == "CFO") {
            this.$router.push("/cfo_payment");
            return;
          } else if (user.role == "Attendance Verifier") {
            this.$router.push("/webinar-scheduler");
            return;
          } else if (user.role == "Revenue") {
            this.$router.push("/revenue-setup");
            return;
          } else if (user.adm_approval_reqd && user.partner_type == "Sponsor") {
            this.$router.push("/approvals");
            return;
          } else if (
            user.partner_payment_required ||
            user.role == "Business Reviewer" ||
            user.role == "Business"
          ) {
            this.$router.push("/admissions");
            return;
          } else if (user.adm_approval_reqd || user.role == "Coordinator") {
            this.$router.push("/set_payment_options");
            return;
          } else if (user.role == "Partner") {
            this.$router.push("/admissions");
            return;
          } else if (user.role == "Document Viewer") {
            this.$router.push("/student_document_viewer");
            return;
          } else if (user.role == "Approver") {
            this.$router.push("/document_requests");
            return;
          } else if (user.role == "COE") {
            this.$router.push("/exam_results");
            return;
          }
          this.$router.push("/operational_dashboard");
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          if (
            errorMessage == "User does not exist" ||
            errorMessage == "Password is invalid"
          ) {
            this.$store.commit("showSnackbar", {
              message: "Invalid credentials",
              color: "error",
            });
          } else {
            this.$store.commit("showSnackbar", {
              message: errorMessage,
              color: "error",
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.title-login {
  font-family: "Playwrite GB S", cursive;
}
</style>
